import { ElemAttributesTypes } from './types';
import { ElementRetainRuleRecord } from '@fullstory/proto/fs/services/ingestion-settings';
import { ElemAttributesRequestActions } from './actions';
import { combineReducers } from '@fullstory/redux-util/utils';
import { int64 } from '@fullstory/proto/google/protobuf';

export function elemAttributesById(
  state: Map<int64, ElementRetainRuleRecord> = new Map<int64, ElementRetainRuleRecord>(),
  action: ElemAttributesRequestActions,
): Map<int64, ElementRetainRuleRecord> {
  switch (action.type) {
    case ElemAttributesTypes.GetElemAttributesSuccess: {
      const nextState = new Map<int64, ElementRetainRuleRecord>();
      action.data.rules.forEach((record: ElementRetainRuleRecord) => {
        if (!record.rule) return;
        nextState.set(record.rule.id, record);
      });
      return nextState;
    }

    case ElemAttributesTypes.SetElemAttributeSuccess: {
      const nextState: Map<int64, ElementRetainRuleRecord> = new Map(state);
      if (action.data.rule) {
        nextState.set(action.data.rule.id, action.data);
      }
      return nextState;
    }

    case ElemAttributesTypes.ArchiveElemAttributeSuccess: {
      const nextState: Map<int64, ElementRetainRuleRecord> = new Map(state);
      if (action.data.rule) {
        nextState.delete(action.data.rule.id);
      }
      return nextState;
    }
  }

  return state;
}

type SettingsElementAttributesState = {
  elemAttributesById: ReturnType<typeof elemAttributesById>;
};

export const settingsElementAttributes = combineReducers<SettingsElementAttributesState>({
  elemAttributesById,
});
